import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M13.953 9.6h6M13.953 12.6h5M13.953 15.6h3M11.893 5.152h8.345c1.047 0 1.896.849 1.896 1.896v11.466c0 1.047-.849 1.896-1.896 1.896H6.635"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M6.6 12c-1.659 0-3-1.47-3-3.288V5.288C3.6 3.47 4.941 2 6.6 2s3 1.47 3 3.288v3.443C9.6 10.53 8.26 12 6.6 12ZM6.583 17.522V15.41"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M11.6 11c0 2.211-2.392 4-5 4s-5-1.789-5-4"
    />
  </svg>
);
export const Transcribe2Icon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
